
/**
 * Application
 *
 * Copyright (c) 2015 - Metabolism
 *
 * License: GPL
 * Version: 2
 *
 * Requires:
 *   - VueJS
 *
 **/

'use strict';

// detect browser and add class to html
if( typeof bowser !== 'undefined' )
{
	var browser   = bowser;
	browser.touch = ('ontouchstart' in window || navigator.msMaxTouchPoints || false);
	var browser_class = ' ' + browser.name + ' ' + browser.name + '-' + browser.version + ' ' + browser.osname + ' ' + browser.osname + '-' + browser.osversion + ' ' + (browser.touch ? 'touch' : 'no-touch');
	document.documentElement.className += browser_class.toLowerCase();
}

// set global delimiters
Vue.config.delimiters = ['[[', ']]'];

Vue.use(VueResource);

// start app
var app = new Vue({
	el: '#app',
	delimiters: ['[[', ']]'],
	data: function(){
		return{
			showModalVideo: false
		}
	},
	mounted: function(){

		var body_classList = document.body.classList;
		body_classList.remove('loading');
		body_classList.add('loaded');
	}
});


